
import http from './HttpService';
import qs from 'qs';

const ApiService = {
  get(endpoint, params = {}) {
    return http.get(endpoint, { params, paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }) });
  },
  post(endpoint, data) {
    return http.post(endpoint, data);
  },
  // Add other methods as needed (put, delete, etc.)
};

export default ApiService;

